export { UserRemove as default } from './UserRemove';
